import script from "./EditIndividualBusiness.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditIndividualBusiness.vue?vue&type=script&lang=ts&setup=true"

import "./EditIndividualBusiness.vue?vue&type=style&index=0&id=dc9fe3ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc9fe3ea"]])

export default __exports__